import AppLoadingScreen from "./AppLoadingScreen";

export default AppLoadingScreen;